<template>
  <div>
    <small v-if="!rows.length" class="text-color-secondary">
      Select countries in Geo Whitelist above to set a custom split.
    </small>

    <div v-else class="geo-distribution-grid">
      <div v-for="row in rows" :key="row.geo" class="geo-distribution-card">
        <span class="geo-distribution-name">{{ countryName(row.geo) }}</span>
        <InputNumber
          :modelValue="row.pct"
          @update:modelValue="updateRow(row.geo, $event)"
          :min="0"
          :max="100"
          :minFractionDigits="0"
          :maxFractionDigits="0"
          suffix="%"
          class="geo-distribution-input"
          :inputStyle="{ width: '100%' }"
          :class="{ 'p-invalid': submitted && row.pct == null }"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import InputNumber from "primevue/inputnumber";

// eslint-disable-next-line no-undef
const props = defineProps({
  countries: {
    type: Array,
    required: true,
  },
  rows: {
    type: Array,
    required: true,
  },
  submitted: {
    type: Boolean,
    default: false,
  },
});

// eslint-disable-next-line no-undef
const emit = defineEmits(["update:rows"]);

const countryName = (geo) =>
  props.countries.find((c) => c.geo === geo)?.name || geo?.toUpperCase();

const updateRow = (geo, pct) => {
  emit(
    "update:rows",
    props.rows.map((row) => (row.geo === geo ? { ...row, pct } : row))
  );
};
</script>

<style scoped>
.geo-distribution-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  max-height: 13rem;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.geo-distribution-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  border: 1px solid var(--surface-border);
  border-left: 4px solid var(--primary-color);
  border-radius: 12px;
  padding: 0.6rem 1rem;
}

.geo-distribution-name {
  font-weight: 600;
}

.geo-distribution-input {
  max-width: 110px;
  flex: none;
}

@media (max-width: 640px) {
  .geo-distribution-grid {
    grid-template-columns: 1fr;
  }
}
</style>
